import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { IoArrowUndo } from 'react-icons/io5';
import { useNavigate } from 'react-router';
import { getToken, URI } from '../../Conexiones/Conexion';
import moment from 'moment-timezone';
import '../../CSS/Materiales.css';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { BsFiletypePdf } from 'react-icons/bs';
import autoTable from 'jspdf-autotable'
import { jsPDF } from "jspdf";
import watermark from "../../Img/watermark.png"
import { calibriBold,calibriRegular } from "../../Fonts/font";

function PagosCampo() {
    const navigate = useNavigate()
    const [pagosCampo, setPagosCampo] = useState([])
    //FECHA Y HORA
    const getdatetime = moment()
    const today= getdatetime.tz('America/Mexico_City').format('YYYY-MM-DD')
    const hora= getdatetime.tz('America/Mexico_City').format('HH')
    const diaSemana= moment("2023-11-20").day();

    //MODAL EDIT
    const [showEdit, setShowEdit] = useState(false);
    const [idEmpleado, setIdEmpleado] = useState("");
    const [fecha, setFecha] = useState("");
    const [tipo, setTipo] = useState("")
    const [editDeduccion, setEditDeduccion] = useState("");
    const [deduccion, setDeduccion] = useState("");
    const [fechas, setFechas] = useState([]);
    const [inicio, setInicio] = useState([]);

    const handleShowEdit = (empleado,deduccion) =>{
                setShowEdit(true);
                setIdEmpleado(empleado);
                setEditDeduccion(deduccion);
                getFechas(empleado,inicio);
                
    } 

    const handleCloseEdit = () =>{
        setDeduccion("");
        setFecha("");
        setShowEdit(false);
    } 
    
    //MODAL PDF
    const [showPdf, setShowPdf] = useState(false);
    const [pdfFecha, setpdfFecha] = useState(today);

    const handleClosePdf = () => {
        setShowPdf(false);
    }
    const handleShowPdf = () =>{
        setShowPdf(true);
    } 

    const regresar = () => {
        navigate('/inicio/oficina')
    }

    const getNomimaPDF = async () =>{
            var registros = []
            var totalSemana ;
            var ini;
            var fin ;

            const res = await axios.get(URI + 'getNomina/'+pdfFecha,{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
            )
            registros=res.data.asistencia
            ini=res.data.inicio
            fin=res.data.fin
            totalSemana = res.data.totalSemana;
            descargar(registros,ini,fin,totalSemana)
    }
    
    const descargar = async (registros,ini,fin,totalSemana) => {
           if(registros.length===0){
            handleClosePdf();
            Swal.fire({
                text:'NO EXISTEN REGISTROS DE LA FECHA SELECCIONADA',                 
                icon: 'info',
                iconColor:'#1A2E4F',
                confirmButtonColor: '#1A2E4F',
                confirmButtonText: 'ACEPTAR',
                timer: 5000,
                toast:true
            })
           }else{
                handleClosePdf();
                var dateGeneral = moment( new Date());
                const fechaGeneral = dateGeneral.tz('America/Mexico_City').format('DD/MM/YYYY')
                var docGeneral = new jsPDF({format: 'letter',orientation:"portrait"});
                var company_logoGeneral = {
                    w: 30,
                    h: 20
                };

                var startYGeneral=0;
                //IMAGEN
                var imgDataGeneral ="https://www.app-system.rosmocoin.com/rosmo-img/rosmo-logo-v2.png"
                docGeneral.addImage(imgDataGeneral,'JPEG',10,25,company_logoGeneral.w,company_logoGeneral.h);
                //TITULO
                docGeneral.addFileToVFS("calibri-bold.ttf", calibriBold);
                docGeneral.addFont('calibri-bold.ttf', 'calibri-bold', 'bold');
                docGeneral.setFont("calibri-bold","bold");
                docGeneral.setFontSize(18);
                docGeneral.setTextColor("#002060")
                docGeneral.text("NÓMINA CAMPO", docGeneral.internal.pageSize.getWidth() / 2, 38, null, 'center');
                //LINEA #1
                docGeneral.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                docGeneral.setLineWidth(2.5);    
                docGeneral.line(10, 18, 205, 18); // vertical line    
                //console.log(doc.internal.pageSize.getWidth())
                //obra,ubicación,ciudad,estado (TIPO DE LETRA BOLD)
                docGeneral.setFont("calibri-bold","bold");
                docGeneral.setFontSize(10);
                docGeneral.setTextColor("black")
                docGeneral.text("FECHA:", 167, 45, null, 'right');
                docGeneral.text("SEMANA:", 167, 49, null, 'right');
                //FECHA DESCARGA
                docGeneral.addFileToVFS("calibri-regular.ttf", calibriRegular);
                docGeneral.addFont('calibri-regular.ttf', 'calibri-regular', 'normal');
                docGeneral.setFont("calibri-regular","normal");
                docGeneral.setFontSize(10);
                docGeneral.text(fechaGeneral, 176, 45, null, 'center');
                docGeneral.text(ini+" - " +fin, 186, 49, null, 'center');
                //LINEA #2
                docGeneral.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                docGeneral.setLineWidth(1.0);    
                docGeneral.line(10, 53, 205, 53); // vertical line  
                        
                //TABLA
                var rowsGeneral = registros;
                //console.log(rows)
                //const last = rows[rows.length-1];
                //const totalSemana=last.totalSemana;
                
                let datosGeneral = []
                rowsGeneral.forEach((element) => {
                        datosGeneral.push([element.nombreEmp.toUpperCase(),
                        element.nameL.toUpperCase(),element.nameM.toUpperCase(),element.nameMC.toUpperCase(),
                        element.nameJ.toUpperCase(),element.nameV.toUpperCase(),element.nameS.toUpperCase(),
                        element.totalAsis,'$'+formato(element.precio),'$'+formato(element.extra),
                        '$'+formato(element.deduccion),'$'+formato(element.total)])
                });

                //console.log(datos)
                //TABLA
                autoTable(docGeneral,
                        {head: [['EMPLEADO','L', 'M','X','J','V','S','DIAS','PRECIO','EXT','DED','TOTAL']],
                    body:datosGeneral,
                    margin: {right:10, left:10 },
                    headStyles :{halign:'center',lineWidth:1,lineColor:"#1A2E4F"},
                    startY: 60,
                    theme:"plain",
                    columnStyles:{
                        0: {halign:"center"},
                        1: {halign:"center"},
                        2: {halign:"center"},
                        3: {halign:"center"},
                        4: {halign:"center"},
                        5: {halign:"center"},
                        6: {halign:"center"},
                        7: {halign:"center"},
                        8: {halign:"center"},
                        9: {halign:"center"},
                        10: {halign:"center"},
                        11: {halign:"center"}
                    }
                })
                startYGeneral=docGeneral.lastAutoTable.finalY;
                //LINEA AL FINAL DE LA TABLA
                docGeneral.setDrawColor("black", 0, 0); // draw red lines    
                docGeneral.setLineWidth(1.0);    
                docGeneral.line(10, startYGeneral, 205, startYGeneral); // vertical line  
                //TOTALES
                docGeneral.setFont("calibri-bold","bold");
                docGeneral.setFontSize(12);
                docGeneral.setTextColor("black")
                docGeneral.text("TOTAL", 160, startYGeneral+15); 
                docGeneral.text("$ "+formato(totalSemana), 204, startYGeneral+15,"right");  
                //docGeneral.text("$ "+formato(totalSemana), 204, startYGeneral+15,"right");  
                //FOOTER//FOOTER
                const pageCountGeneral = docGeneral.internal.getNumberOfPages();

                // For each page, print the page number and the total pages
                for(var j = 1; j <= pageCountGeneral; j++) {
                    //MARCA DE AGUA
                    var logoGeneral = new Image();
                    logoGeneral.src = watermark;
                    docGeneral.addImage(logoGeneral, 'JPEG',32.945, 89.7,150,100);
                    // Go to page i
                    docGeneral.setPage(j);
                    //Print Page 1 of 4 for example
                    docGeneral.text('Página ' + String(j) + ' de ' + String(pageCountGeneral),210-20,300-30,null,null,"right");
                }
                docGeneral.save('NOMINA'+fechaGeneral+'.pdf');
            }
    }

    const getPagosCampo = async (f) =>{
        const res = await axios.get(URI + 'asistencia-general/'+f,{
            headers: {
                'Authorization': `Bearer ${getToken()}`
            },
            }).catch(
                err =>{
                    if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                        navigate('/')
                    }
                }
            )
        setPagosCampo(res.data.asistencia)
        setInicio(res.data.inicio)
        setTipo(res.data.tipo)
    }

    useEffect(()=>{
    const getPagos = async () =>{
        const getdatetime = moment()
        const today= getdatetime.tz('America/Mexico_City').format('YYYY-MM-DD')
        //const hora= getdatetime.tz('America/Mexico_City').format('HH')

        const res = await axios.get(URI + 'asistencia-general/'+today,{
            headers: {
                'Authorization': `Bearer ${getToken()}`
            },
            }).catch(
                err =>{
                    if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                        navigate('/')
                    }
                }
            )
        setPagosCampo(res.data.asistencia)
        setInicio(res.data.inicio)
        setTipo(res.data.tipo)
    }
    getPagos();
    },[navigate])

    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2)
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }

    const getDeduccion = async (fechaSelect) =>{
        const res = await axios.get(URI+'getDeduccion/'+idEmpleado+"/"+fechaSelect,{
            headers: {
                'Authorization': `Bearer ${getToken()}`
            },
            }).catch(
                err =>{
                    if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                        navigate('/')
                    }
                }
            )
       setDeduccion(res.data[0].deduccion)
    };

    const handleFecha = (event) =>{
        setFecha(event.value)
        getDeduccion(event.value);
    }


    const getFechas = async (empleado,inicio) =>{
        const res = await axios.get(URI+'fechasPagos/'+inicio+'/'+empleado,{
            headers: {
                'Authorization': `Bearer ${getToken()}`
            },
            }).catch(
                err =>{
                    if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                        navigate('/')
                    }
                }
            )
        setFechas(res.data)
    }

    const update= async (e) => {
        e.preventDefault()
        await axios.put(URI+'addDeduccion/',{e:idEmpleado,f:fecha,d:editDeduccion}).then(
            res => {                
                if(res.data.message === "connect ECONNREFUSED 127.0.0.1:3306"){
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                      )
                }else{
                    if(res.data.message==="¡Deducción agregada!"){
                        getPagosCampo(pdfFecha);
                        handleCloseEdit();
                        Swal.fire({
                            text:res.data.message,                 
                            icon: 'info',
                            iconColor:'#1A2E4F',
                            showConfirmButton:false,
                            timer: 5000,
                            toast:true,
                        })
                    }else{
                        Swal.fire({
                            title: '¡ERROR!',
                            text: res.data.message,                 
                            icon: 'error',
                            confirmButtonColor: 'red',
                            confirmButtonText: 'ACEPTAR'
                        })
                    }
                }
            }
        ).catch(
            err => {
                if(err.message === "Network Error"){
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                    )
                }else{
                    Swal.fire(
                        'Falla en el servidor...',
                        err.message,
                        'question'
                    )
                }
            }
        )
    }


  return (
    <>
     <div className="materiales">
            <div >
                <h3 className="text-uppercase tituloGastos">PAGOS EN CAMPO</h3>
                <IoArrowUndo title="REGRESAR" onClick={regresar} style={{position:'absolute', right:'40px', top:'60px', fontSize:'40px', cursor:'pointer', color:'#1A2E4F'}}/>
            </div>
            <div className='divbotonE'  >                                                                                             
                <div className='botonE' style={{display:'flex', justifyContent:'space-between',marginTop:"40px"}} >
                    <button  className="btn btncolor" onClick={handleShowPdf}><BsFiletypePdf />DESCARGAR</button>
                    <div className="fecha" style={{display:'flex', justifyContent:'space-between'}}>
                        <input type="date" className="form-control"  onChange={(e)=>setpdfFecha(e.target.value)} 
                        defaultValue={pdfFecha}/>   
                        <button type="button" className="btn btncolor" onClick={()=> getPagosCampo(pdfFecha)}  >BUSCAR</button>                                                                                             
                    </div>
                </div>
            </div>
            { pagosCampo.length === 0 ? (<h3 style={{marginTop:'30vh'}}>NO HAY REGISTROS</h3>):(
                            <div className="tabla-gastos" style={{marginTop:"20px"}} >
                            <div className="table tabla">
                            { tipo === 1 ? (
                                <table className="table text-uppercase">
                                            <thead >
                                                <tr >  
                                                    <th>empleado</th>                           
                                                    <th>L</th>
                                                    <th>M</th>
                                                    <th>X</th>
                                                    <th>J</th>
                                                    <th>V</th>
                                                    <th>S</th>
                                                    <th>dias</th>
                                                    <th>precio</th>
                                                    <th>extra</th>
                                                    <th>deducción</th>
                                                    <th>total</th>
                                                    <th>Editar</th>
                                                </tr>
                                            </thead> 
                                            <tbody >
                                                    {pagosCampo.map(p =>{
                                                        return(
                                                            <tr key={p.num}>
                                                                <td>{p.nombreEmp}</td>
                                                                    <td >{p.nameL}</td>
                                                                    <td>{p.nameM}</td>
                                                                    <td>{p.nameMC}</td>
                                                                    <td>{p.nameJ}</td>
                                                                    <td>{p.nameV}</td>
                                                                    <td>{p.nameS}</td>
                                                                    <td>{p.totalAsis}</td>
                                                                    <td>${formato(p.precio)}</td>
                                                                    <td>${formato(p.extra)}</td>
                                                                    <td>${formato(p.deduccion)}</td>
                                                                    <td>$ {formato(p.total)}</td>
                                                                    <td><div className="btn iconoH" onClick={() => handleShowEdit(p.idEmpleado,p.deduccion)} style={{margin:'5px'}}>
                                                                                <span className="bi bi-pen" title="EDITAR"></span></div>
                                                                    </td>
                                                            </tr>                             
                                                    )})}     
                                            </tbody>
                                </table>):
                                (<table className="table text-uppercase">
                                                <thead >
                                            <tr >  
                                                <th>empleado</th>                           
                                                <th>L</th>
                                                <th>M</th>
                                                <th>X</th>
                                                <th>J</th>
                                                <th>V</th>
                                                <th>S</th>
                                                {/*<th>dias</th>
                                                <th>precio</th>
                                                <th>extra</th>
                                                <th>total</th>*/}
                                                <th>deducción</th>
                                                <th>Editar</th>
                                            </tr>
                                                </thead> 
                                                <tbody >
                                                        {pagosCampo.map(p =>{
                                                            return(
                                                                <tr key={p.num}>
                                                                    <td>{p.nombreEmp}</td>
                                                                        <td >{p.nameL}</td>
                                                                        <td>{p.nameM}</td>
                                                                        <td>{p.nameMC}</td>
                                                                        <td>{p.nameJ}</td>
                                                                        <td>{p.nameV}</td>
                                                                        <td>{p.nameS}</td>
                                                                        <td>${formato(p.deduccion)}</td>
                                                                        <td>
                                                                        <div className="btn iconoH" onClick={() => handleShowEdit(p.idEmpleado,p.deduccion)} style={{margin:'5px'}}>
                                                                                    <span className="bi bi-pen" title="EDITAR"></span>
                                                                        </div></td>
                                                                </tr>                             
                                                        )})}     
                                                </tbody>
                                </table> )}
            
                            </div>      
                    </div>
            )}
    </div>

        {/*EDITAR ACTIVIDAD*/}
        <Modal  show={showEdit} onHide={handleCloseEdit} id="modal-deduccion">
            <Modal.Header className=' btncolor'>
                <Modal.Title>AGREGAR DEDUCCIÓN</Modal.Title>
                <CloseButton  style={{backgroundColor:"white"}} onClick={handleCloseEdit}/>
            </Modal.Header>
            <form>
            <Modal.Body  style={{textAlign:'left'}}>
                    <div className="mb-3">
                        <Select
                                placeholder ="Seleccionar fecha"
                                required
                                options={fechas.map(f=>({label:f.dayName+" - "+moment(f.fecha).format("DD/MM/YYYY"),value:f.fecha}))}
                                onChange={handleFecha}
                        />
                    </div>
                    <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Deducción</label>
                                <input type = "number" className="form-control"  id="exampleFormControlInput1"
                                onChange={e => setEditDeduccion(e.target.value)} defaultValue={deduccion} />
                    </div>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" className="btn btn-secondary" onClick={handleCloseEdit}>CANCELAR</Button>
                {editDeduccion ==="" || fecha === ""? <Button type="submit" className="btn btn-light btncolor" disabled>GUARDAR CAMBIOS</Button>                                                
                : <Button type="submit" className="btn btn-light btncolor" onClick={update}>GUARDAR CAMBIOS</Button>  }                                            
            </Modal.Footer>
            </form>
        </Modal>  
        
        {/*PDF*/}
        <Modal  show={showPdf}  onHide={handleClosePdf} >
                                    <Modal.Header className=' btncolor'>
                                        <Modal.Title>DESCARGAR PDF</Modal.Title>
                                        <CloseButton onClick={handleClosePdf} style={{backgroundColor:"white"}} />
                                    </Modal.Header>
                                    <form >
                                    <Modal.Body  style={{textAlign:'left'}}>
                                            <h5>¿Quieres descargar el pdf?</h5>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button type="button" className="btn btn-secondary" onClick={handleClosePdf}>CANCELAR</Button>                                               
                                        <Button type="button" className="btn btn-light btncolor" onClick={getNomimaPDF}>DESCARGAR</Button>                                                     
                                    </Modal.Footer>
                        </form>
        </Modal>  
    </>
   )}

export default PagosCampo;